import { useMemo } from "react";
import type { Product } from "@/types/products";
import type { ProductVariation } from "@/types/productVariations";
import type { DisplayPrices } from "@/features/productVariations/types";

const useDisplayPrices = (product: Product | null, matchedVariation: ProductVariation | null) => {
  const displayPrices = useMemo(() => {
    const defaultPrices: DisplayPrices = {
      on_sale: false,
      price: "",
      regular_price: "",
      price_range: null,
    };

    if (!product) return defaultPrices;

    if (matchedVariation) {
      const { on_sale, price, regular_price } = matchedVariation;
      return { on_sale, price, regular_price, price_range: null };
    }

    const { price, regular_price, price_range } = product.prices;
    return { on_sale: product.on_sale, price, regular_price, price_range };
  }, [product, matchedVariation]);

  return displayPrices;
};

export default useDisplayPrices;
